import { createSelector } from 'reselect';
import CarditResditEventOverviewDefaultViewColumns from '../../containers/CarditResditEventOverviewDefaultViewColumns';
import CarditResditEventOverviewAllLegsViewColumns from '../../containers/CarditResditEventOverviewAllLegsViewColumns';

export const getGeneratedOnDateTime = state => state.reporting.CARDIT_RESDIT_EVENT_OVERVIEW_105.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.CARDIT_RESDIT_EVENT_OVERVIEW_105.isLoading;

export const getData = state => state.reporting.CARDIT_RESDIT_EVENT_OVERVIEW_105.data;

export const getDefaultViewColumns =
  createSelector(getData, CarditResditEventOverviewDefaultViewColumns);

export const getAllLegViewColumns =
  createSelector(getData, CarditResditEventOverviewAllLegsViewColumns);
